import React, { Component } from 'react';
import './AbilityToCompete.css';
import WeightBenefits from './WeightBenefits/WeightBenefits';
import CriticalCapabilities from './CriticalCapabilities/CriticalCapabilities';
import DefineCompetitors from './DefineCompetitors/DefineCompetitors';
import RateBenefits from './RateBenefits/RateBenefits';
import Result from './Result/Result';

class AbilityToCompete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            groupStepState: 1,
            disableNextState: false,
            tabStep: 0
        };
    }
    componentWillMount(){
        this.props.getBenefitsLadder({
            projectId: this.props.projectId,
            type: "benefitsLadder"
        })
        localStorage.setItem("openedTool", this.props.projectId);
    }

    groupStateNext = () => {
        this.setState({ groupStepState: this.state.groupStepState + 1 })
    }

    groupStateBack = () => {
        this.setState({ groupStepState: this.state.groupStepState - 1 })
    }
    disableNextModal = () => {
        this.setState({ disableNextState: !this.state.disableNextState })
    }
    onTabChange=(number)=>{
        this.setState({tabStep: number})
    }

    render() {
        return (
            <div className='projects-content challenge-statement-content'>
                <div>
                    {this.state.groupStepState === 1 && this.props.benefits.benefitsLadderFetched &&
                        <WeightBenefits
                            groupStepState={this.state.groupStepState}
                            getCustomerSegment={this.props.getCustomerSegment}
                            compete={this.props.compete}
                            projectId={this.props.projectId}
                            getCompete={this.props.getCompete}
                            getBenefits={this.props.getBenefits}
                            getChallengeStatements={this.props.getChallengeStatements}
                            challengeStatement={this.props.challengeStatement}
                            createAbilityOfCompete={this.props.createAbilityOfCompete}
                            editAbilityOfCompete={this.props.editAbilityOfCompete}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            benefits={this.props.benefits}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                            getSegmentation={this.props.getSegmentation}
                            segmentation={this.props.segmentation}
                        />
                    }
                    {this.state.groupStepState === 2 &&  this.props.benefits.benefitsLadderFetched &&
                        <CriticalCapabilities
                            groupStepState={this.state.groupStepState}
                            getCustomerSegment={this.props.getCustomerSegment}
                            compete={this.props.compete}
                            projectId={this.props.projectId}
                            getCompete={this.props.getCompete}
                            getBenefits={this.props.getBenefits}
                            getChallengeStatements={this.props.getChallengeStatements}
                            challengeStatement={this.props.challengeStatement}
                            createAbilityOfCompete={this.props.createAbilityOfCompete}
                            editAbilityOfCompete={this.props.editAbilityOfCompete}
                            groupStateNext={this.groupStateNext}
                            groupStateBack={this.groupStateBack}
                            benefits={this.props.benefits}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 3 && this.props.benefits.benefitsLadderFetched &&
                        <DefineCompetitors
                            groupStepState={this.state.groupStepState}
                            getCustomerSegment={this.props.getCustomerSegment}
                            compete={this.props.compete}
                            projectId={this.props.projectId}
                            getCompete={this.props.getCompete}
                            getBenefits={this.props.getBenefits}
                            getChallengeStatements={this.props.getChallengeStatements}
                            challengeStatement={this.props.challengeStatement}
                            createAbilityOfCompete={this.props.createAbilityOfCompete}
                            editAbilityOfCompete={this.props.editAbilityOfCompete}
                            groupStateNext={this.groupStateNext}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            groupStateBack={this.groupStateBack}
                            editCompetitorsGroups={this.props.editCompetitorsGroups}
                            competitiveAnalysis={this.props.competitiveAnalysis}
                            benefits={this.props.benefits}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 4 && this.props.benefits.benefitsLadderFetched && 
                        <RateBenefits
                            groupStepState={this.state.groupStepState}
                            getCustomerSegment={this.props.getCustomerSegment}
                            compete={this.props.compete}
                            projectId={this.props.projectId}
                            getCompete={this.props.getCompete}
                            getBenefits={this.props.getBenefits}
                            getChallengeStatements={this.props.getChallengeStatements}
                            challengeStatement={this.props.challengeStatement}
                            createAbilityOfCompete={this.props.createAbilityOfCompete}
                            editAbilityOfCompete={this.props.editAbilityOfCompete}
                            groupStateNext={this.groupStateNext}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            groupStateBack={this.groupStateBack}
                            editCompetitorsGroups={this.props.editCompetitorsGroups}
                            benefits={this.props.benefits}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                    {this.state.groupStepState === 5 && this.props.benefits.benefitsLadderFetched &&
                        <Result
                            groupStepState={this.state.groupStepState}
                            getCustomerSegment={this.props.getCustomerSegment}
                            compete={this.props.compete}
                            projectId={this.props.projectId}
                            getCompete={this.props.getCompete}
                            getBenefits={this.props.getBenefits}
                            getChallengeStatements={this.props.getChallengeStatements}
                            challengeStatement={this.props.challengeStatement}
                            createAbilityOfCompete={this.props.createAbilityOfCompete}
                            editAbilityOfCompete={this.props.editAbilityOfCompete}
                            groupStateNext={this.groupStateNext}
                            getCompetitorsGroups={this.props.getCompetitorsGroups}
                            groupStateBack={this.groupStateBack}
                            editCompetitorsGroups={this.props.editCompetitorsGroups}
                            benefits={this.props.benefits}
                            tabStep={this.state.tabStep}
                            onTabChange={this.onTabChange}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default (AbilityToCompete);



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/AbilityToCompete.jsx